import { useTranslation } from 'react-i18next';
import { TELEGRAM_LINK } from './social-links.constant';

const WalletSupport = () => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className='paragraph-medium text-white'>
        {t('WALLET_SUPPORT_TITLE_1')}{' '}
        <a
          href={TELEGRAM_LINK}
          target='_blank'
          rel='noreferrer noopener'
          className='cursor-pointer text-blue-300 underline'
        >
          Telegram
        </a>
        .
      </div>
      <div className='paragraph-medium text-white'>
        {t('WALLET_SUPPORT_TITLE_2')}.
      </div>
    </>
  );
};

export default WalletSupport;
